import React, { createContext, useReducer, useContext } from 'react';

import { DisclaimerDataProps } from '../components/PrePurchaseDisclaimer';
import { ScreenerDataProps } from '../components/PrePurchaseScreener';

export enum PrePurchaseModalActionsTypes {
  SetPrePurchaseDisclaimer = 'SET_PRE_PURCHASE_DISCLAIMER',
  SetPrePurchaseScreener = 'SET_PRE_PURCHASE_SCREENER',
}

type PrePurchaseModalStateType = {
  elegibleCallback?: () => void;
  isPrePurchaseDisclaimerOpen?: boolean;
  isPrePurchaseScreenerOpen?: boolean;
  prePurchaseDisclaimerData: DisclaimerDataProps | null;
  prePurchaseScreenerData: ScreenerDataProps | null;
};

type PrePurchaseModalActions = {
  payload: Partial<PrePurchaseModalStateType>;
  type: PrePurchaseModalActionsTypes;
};

type PrePurchaseModalContextType = {
  state: PrePurchaseModalStateType;
  dispatch: (action: PrePurchaseModalActions) => void;
};

export const prePurchaseModalInitialState: PrePurchaseModalStateType = {
  isPrePurchaseDisclaimerOpen: false,
  isPrePurchaseScreenerOpen: false,
  prePurchaseDisclaimerData: null,
  prePurchaseScreenerData: null,
};

const contextInitialState = {
  state: prePurchaseModalInitialState,
  dispatch: (action: PrePurchaseModalActions) => null,
};

export const PrePurchaseModalContext =
  createContext<PrePurchaseModalContextType>(contextInitialState);

const reducer = (
  state: PrePurchaseModalStateType,
  action: PrePurchaseModalActions,
): PrePurchaseModalStateType => {
  switch (action.type) {
    case PrePurchaseModalActionsTypes.SetPrePurchaseScreener:
      return {
        ...state,
        isPrePurchaseScreenerOpen: action.payload.isPrePurchaseScreenerOpen,
        prePurchaseScreenerData: action.payload.prePurchaseScreenerData!,
        prePurchaseDisclaimerData:
          action.payload.prePurchaseDisclaimerData ||
          state.prePurchaseDisclaimerData,
        elegibleCallback: action.payload.elegibleCallback,
      };

    case PrePurchaseModalActionsTypes.SetPrePurchaseDisclaimer:
      return {
        ...state,
        isPrePurchaseDisclaimerOpen: action.payload.isPrePurchaseDisclaimerOpen,
        prePurchaseDisclaimerData: action.payload.prePurchaseDisclaimerData!,
      };

    default:
      return state;
  }
};

export const PrePurchaseModalContextProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, prePurchaseModalInitialState);

  return (
    <PrePurchaseModalContext.Provider value={{ state, dispatch }}>
      {children}
    </PrePurchaseModalContext.Provider>
  );
};

// Pre Purchase Modal Context

export const usePrePurchaseModalContext = (): PrePurchaseModalContextType => {
  const contextValue = useContext(PrePurchaseModalContext);

  if (contextValue === undefined) {
    throw new Error(
      'Expected a PrePurchaseModalContext in the React tree to set the context value',
    );
  }

  return contextValue;
};
